import { render, staticRenderFns } from "./clerk-dialog.vue?vue&type=template&id=6cc9dc1a&scoped=true&"
import script from "./clerk-dialog.vue?vue&type=script&lang=js&"
export * from "./clerk-dialog.vue?vue&type=script&lang=js&"
import style0 from "./clerk-dialog.vue?vue&type=style&index=0&id=6cc9dc1a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc9dc1a",
  null
  
)

export default component.exports